const services = [
    {
        name: 'Building Automation',
        img: 'buildingAutomationServicesNew',
        desc: (
            <p>
                Building automation systems provide intelligent control over
                your facility's various mechanical and electrical systems,
                leading to increased efficiency, comfort, and security. Our
                tailored solutions integrate HVAC, lighting, security, and other
                critical functions into a unified, easily manageable platform.
                <br />
                <br />
                By implementing sophisticated control strategies and leveraging
                real-time data, we empower you to optimize energy consumption,
                streamline operations, and create a more responsive and
                sustainable building environment. Our team specializes in
                designing, installing, and maintaining these advanced systems.
            </p>
        ),
        points: [
            'Design and implementation of integrated building automation systems',
            'Seamless integration of HVAC, lighting, and security controls',
            'Development of customized control strategies for optimal performance',
            'Installation of user-friendly building management system interfaces',
            'Remote monitoring and control capabilities for enhanced accessibility',
            'Energy management solutions to reduce consumption and costs',
            'Data analytics and reporting for informed decision-making',
            'Scalable systems to adapt to your evolving building needs',
            'Ongoing support and maintenance to ensure system reliability',
        ],
    },
    {
        name: 'Plumbing & Gas Fitting',
        img: 'plumbingService',
        desc: (
            <p>
                Our certified plumbers and gas fitters provide a comprehensive
                range of services for commercial, industrial, and institutional
                clients. We handle everything from the installation of complex
                piping systems to the maintenance and repair of essential water
                and gas infrastructure. Safety and compliance are our top
                priorities, ensuring all work is performed to the highest
                industry standards.
                <br />
                <br />
                With years of experience serving diverse sectors, our team is
                adept at troubleshooting issues efficiently and delivering
                reliable solutions. Whether it's a new construction project, a
                system upgrade, or emergency repairs, you can count on our
                expertise to keep your operations running smoothly and safely.
            </p>
        ),
        points: [
            'Expert design, build, and maintenance of plumbing systems',
            'Professional installation and servicing of gas-fired equipment',
            'Efficient replacements, retrofits, and system expansions',
            'Implementation of preventative, proactive, and predictive maintenance',
            'Installation and maintenance of hydronic heating systems',
            'Certified backflow prevention device installation and testing',
            'Thorough diagnostic assessments and effective repair solutions',
            'Temperature control solutions for domestic water systems',
            'Compliance with all relevant codes and safety regulations',
        ],
    },
    {
        name: 'HVAC Systems',
        img: 'hvacService',
        desc: (
            <p>
                Heating, ventilation, and air conditioning (HVAC) systems are
                fundamental to creating comfortable and healthy indoor
                environments. Our expertise encompasses the full lifecycle of
                these critical systems, ensuring optimal performance and energy
                efficiency for your commercial, industrial, or institutional
                space.
                <br />
                <br />
                From initial design and seamless installation to proactive
                maintenance and responsive repairs, our certified technicians
                are equipped to handle all your HVAC needs. We understand the
                importance of reliable climate control and are committed to
                delivering solutions that meet your specific requirements.
            </p>
        ),
        points: [
            'Comprehensive design and build services for HVAC systems',
            'Expert installation of new units and system expansions',
            'Efficient replacements and cost-effective retrofits',
            'Customized preventative maintenance programs to maximize lifespan',
            'Proactive and predictive maintenance strategies to avoid downtime',
            'Thorough diagnostic assessments and accurate troubleshooting',
            'Implementation of advanced temperature control technologies',
            'Precise air balancing for optimal comfort and efficiency',
            'Solutions focused on enhancing energy efficiency and reducing costs',
        ],
    },
    {
        name: 'Mechanical Insulation',
        img: 'insulationService',
        desc: (
            <p>
                Mechanical insulation plays a crucial role in energy efficiency,
                process control, and personnel safety within commercial and
                industrial facilities. Our insulation services are designed to
                minimize heat loss or gain, maintain consistent temperatures in
                piping and equipment, and protect against burns.
                <br />
                <br />
                We offer a variety of insulation materials and application
                techniques tailored to your specific needs and operating
                conditions. Our experienced team ensures proper installation for
                optimal performance and longevity, contributing to reduced
                energy consumption and a safer working environment. We handle
                projects of all sizes with meticulous attention to detail.
            </p>
        ),
        points: [
            'Design and installation of insulation for piping and equipment',
            'Application of various insulation materials for different temperature ranges',
            'Thermal insulation to minimize energy loss and maintain process temperatures',
            'Acoustical insulation to reduce noise transmission',
            'Cryogenic insulation for low-temperature applications',
            'Heat tracing and insulation combinations for temperature maintenance',
            'Removal and replacement of existing insulation materials',
            'Detailed assessments and recommendations for insulation upgrades',
            'Compliance with industry standards for safety and performance',
        ],
    },
];

export default services;
